/* ==========================================================================
   Cart: drawer open/close, quantity changes, remove, gift options.
   Works for both the drawer and the /cart page — every element marked
   [data-cart-section] is re-rendered after a change (Section Rendering API).
   ========================================================================== */
(function () {
  'use strict';

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let lastFocus = null;
  let noteTimer = null;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function sectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('[data-cart-section]'), function (el) {
      return el.dataset.cartSection;
    });
  }

  /* ---- Open / close ---- */
  function open() {
    const d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(function () { d.querySelector('.cart-drawer__panel').focus(); }, 50);
    return true;
  }

  function close() {
    const d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  /* ---- Re-render from Section Rendering API response ---- */
  function render(sections, shouldOpen) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      const target = document.querySelector('[data-cart-section="' + id + '"]');
      if (!target || !sections[id]) return;
      const doc = new DOMParser().parseFromString(sections[id], 'text/html');
      const fresh = doc.querySelector('[data-cart-section] [data-cart-panel]') || doc.querySelector('[data-cart-panel]');
      const current = target.querySelector('[data-cart-panel]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      // Drawer header count lives outside the body; refresh it too
      const freshCount = doc.querySelector('[data-cart-drawer-count]');
      const count = target.querySelector('[data-cart-drawer-count]');
      if (freshCount && count) count.textContent = freshCount.textContent;
      if (freshCount) updateHeaderCount(parseInt(freshCount.textContent.replace(/\D/g, ''), 10) || 0);
    });
    if (shouldOpen) open();
  }

  function updateHeaderCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('cart-count--empty', n === 0);
    });
  }

  /* ---- Cart API helpers ---- */
  function post(endpoint, payload) {
    return fetch(ROOT + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  function setBusy(on) {
    document.querySelectorAll('[data-cart-section]').forEach(function (el) { el.classList.toggle('is-busy', on); });
  }

  function changeLine(line, quantity) {
    setBusy(true);
    post('cart/change.js', { line: line, quantity: quantity, sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (res) { render(res.sections, false); })
      .finally(function () { setBusy(false); });
  }

  /* ---- Events ---- */
  document.addEventListener('click', function (e) {
    // Bag icon in the header opens the drawer instead of going to /cart
    const opener = e.target.closest('[data-cart-open]');
    if (opener && open()) { e.preventDefault(); return; }

    if (e.target.closest('[data-cart-close]')) { close(); return; }

    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const line = parseInt(qtyBtn.closest('[data-line]').dataset.line, 10);
      changeLine(line, Math.max(0, parseInt(qtyBtn.dataset.cartQty, 10)));
    }
  });

  document.addEventListener('change', function (e) {
    const input = e.target;

    if (input.matches('[data-cart-qty-input]')) {
      const line = parseInt(input.closest('[data-line]').dataset.line, 10);
      changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
    }

    if (input.matches('[data-cart-attribute]')) {
      const attrs = {};
      attrs[input.dataset.cartAttribute] = input.checked ? 'Yes' : '';
      post('cart/update.js', { attributes: attrs });
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    const value = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post('cart/update.js', { note: value }); }, 500);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.LenoraCart = { open: open, close: close, render: render, sectionIds: sectionIds };
})();
